const ITEMS = [
  "Gentle — Human Precision",
  "Monster — AI Power",
  "Meta Ads",
  "Creative Strategy",
  "AI Content Studio",
];

export default function Marquee() {
  return (
    <section
      data-testid="section-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-[#27272A] py-6"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {ITEMS.map((t, i) => (
              <span
                key={`${dup}-${i}`}
                className="flex items-center gap-10 px-10 font-display text-2xl font-semibold uppercase tracking-tight sm:text-3xl"
              >
                <span className={i % 2 === 0 ? "text-zinc-500" : "text-outline"}>{t}</span>
                <img src="/assets/logo-duo.png" alt="" className="h-6 w-auto opacity-50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
